import React, { useState, useEffect, Fragment, useRef } from "react";
import {
  Box, Avatar, Typography, Tabs, Tab, TextField, Button, Dialog, DialogContent, DialogTitle,
  Card, CardContent, IconButton, Container, styled, Grid, FormControl, InputLabel, Select, MenuItem, Checkbox, FormControlLabel
} from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon, Visibility, VisibilityOff } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import AlertService from "../../components/Alerts/alerts";
import axios from "axios";
import CloseIcon from '@mui/icons-material/Close';

import AuthService from "../Authentication/auth.service";
import AddressService from './addressService';

const StyledTab = styled(Tab)(({ theme }) => ({
  color: theme.palette.text.secondary,
  '&.Mui-selected': {
    color: theme.palette.error.main,
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
  color: theme.palette.common.white,
  '&:hover': {
    backgroundColor: theme.palette.error.dark,
  },
}));

const API_URL = process.env.REACT_APP_BASEURL;

// Terms and Conditions Dialog Component
const TermsConditionsDialog = ({ open, onClose, t }) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle>
      {t("Terms and Conditions")}
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
        {`
          We wish to open a credit account with IPH PHARMACEUTICALS SDN BHD 
          (1129802-A) and understand that IPH PHARMACEUTICALS SDN BHD (1129802-A) reserves the absolute rights to evaluate and
          determine whether to approve the same or not and should you approve the same,further to determine the level of credit
          and/or terms. We further agree also to all the terms as stated herein below :-

          a. Should our application be successful, the credit terms and credit limit as applied for as in Clause D3 and D4 respectively
          as stated above, and the amount and terms to be approved as stated in Clause G below shall be at the sole discretion
          is not paid after the credit terms, you are entitled to charge us interest at 1.5% per month or judgment rate, whichever
          is higher without prejudice to your right in law

          b. You have the absolute right as you deem fit to alter the credit limit and/or period at any time by giving seven (7) days
          notice to us without giving any reason whatsoever

          c. Within three (3) days of the date of Delivery Order issued by you, (unless notified by writing to you of any defect and/or
          problems, and of which the notice you acknowledge receipt), all goods and / or materials supplied shall be deemed to be the
          correct type, quality and / or acceptable as ordered by us and received in good condition.

          d. That, pursuant to the Credit Reporting Agencies Act 2010 (“Act”), I/We, the following individuals as Directors / Shareholders
          / Business Interest Partieshereby give consent to you to obtain and/or disclose any Credit Information (as defined in the Act)
          relating to me/our company from and/or to Experian Information Services (Malaysia) Sdn. Bhd or any source deemed appropriate
          to verify my/our credit history as you and/or Experian Information Services (Malaysia) Sdn. Bhd or any source deemed appropriate
          may deem fit under any applicable law,regulation, guidelines,regulatory requirement or directive in relation to my/our company’s
          credit application or transaction with you for the following purposes (but not limited to) opening of account, credit evaluation,
          credit/account review,credit/account monitoring, debt recovery purposes, scoring solutions, legal documentation and/or action
          consented to a contract or facility granted. Such consent shall remain applicable as long as I/our company am/is maintaining an
          account/loan/credit/any transaction with you.

          e. Submission of APC and Borang B or F is needed as per the Poison Act 1952 when ordering medications. Annual submission of APC
          (For existing Clinics) and/or Borang B or F (For new clients that purchased the existing clinics/Change of Ownership) is required.
          Failure of submission will result in the inability to purchase medications from us until the stated submission(s) are given
       `}
      </Typography>
    </DialogContent>
  </Dialog>
);


const MyProfile = () => {
  const [tabValue, setTabValue] = useState(0);
  const [userData, setUserData] = useState(JSON.parse(localStorage.getItem("user")));
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [opass, setOpass] = useState("");
  const [showPassword, setShowPassword] = useState({ old: false, new: false, confirm: false });
  const [openPopup, setOpenPopup] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);
  const [storeduser, setStoredUser] = useState(JSON.parse(localStorage.getItem("user")));

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    if (!userData) {
      AuthService.logout();
      navigate("/login");
      window.location.reload();
    } else {
      decryptPass(userData.password);
      fetchAddresses();
    }
  }, []);

  const fetchAddresses = async () => {
    setLoading(true);
    try {
      const response = await AddressService.getAddresses(userData._id);
      if (response.data.status) {
        setAddresses(response.data.data);
      } else {
        AlertService.swalErrorAlert(response.data.message || t("Error fetching addresses."));
      }
    } catch (error) {
      AlertService.swalErrorAlert(t("Error fetching addresses. Please try again."));
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const decryptPass = (pass) => {
    //iph todo: 47
    //console.log("Incoming pass:", pass);
    if (!pass) {
      //iph todo: 47
      //console.log("Pass is undefined or empty");
      return;
    }

    try {
      const dec = atob(pass);
      setOpass(dec);
    } catch (err) {
      console.error("Invalid:", pass);
    }
  };

  const handleUpdateBasicInfo = async (event) => {
    event.preventDefault();
    setLoading(true);
    const formData = new FormData(event.currentTarget);
    const payloadData = {
      functionName: "UpdateCustomerProfile",
      postData: {
        name: formData.get('fullName'),
        phone: formData.get('mobileNumber'),
        _id: userData._id
      },
    };
    SendSubmit(payloadData);
  };

  const handleUpdatePassword = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const oldPassword = formData.get('oldPassword');
    const newPassword = formData.get('newPassword');
    const confirmPassword = formData.get('confirmPassword');

    if (oldPassword !== opass) {
      AlertService.swalErrorAlert(t("Old password is incorrect. Please enter correct old password."));
      return;
    }
    if (newPassword !== confirmPassword) {
      AlertService.swalErrorAlert(t("Passwords do not match."));
      return;
    }

    setLoading(true);
    const payloadData = {
      functionName: "UpdateCustomerPassword",
      postData: {
        old_password: oldPassword,
        new_password: newPassword,
        _id: userData._id
      },
    };
    SendSubmit(payloadData);
  };

  const SendSubmit = (payload) => {
    sendUpdateProfile(payload).then((response) => {
      setLoading(false);
      if (response.data.status) {
        saveUpdatedCreds(payload, response.data.message);
      } else {
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          AlertService.swalErrorAlert(response.data.message || t("Error: Can't update profile at the moment. Please try again later."));
        }
      }
    }).catch((error) => {
      setLoading(false);
      AlertService.swalErrorAlert(t("Network Operation failed."));
    });
  };

  const sendUpdateProfile = (payload) => {
    const headers = {
      'Content-Type': 'application/json',
      'token': localStorage.getItem("session-id")
    };
    return axios.post(API_URL, payload, { headers });
  };

  const saveUpdatedCreds = (payload, msg) => {
    let updatedUser = { ...userData };
    if (payload.postData.name) updatedUser.name = payload.postData.name;
    if (payload.postData.phone) updatedUser.phone = payload.postData.phone;
    if (payload.postData.new_password) updatedUser.password = btoa(payload.postData.new_password);

    localStorage.setItem("user", JSON.stringify(updatedUser));
    setUserData(updatedUser);

    AlertService.swalSuccessAlert(msg || t("Profile updated successfully.")).then(() => {
      window.location.reload();
    });
  };

  const handleAddAddress = () => {
    navigate('/add_address');
  };

  const handleEditAddress = (address) => {
    navigate(`/update_address`, { state: { address } });
  };

  const handleDeleteAddress = async (addressId) => {
    try {
      const response = await AddressService.deleteAddress(addressId);
      if (response.data.status) {
        AlertService.swalSuccessAlert(t("Address deleted successfully."));
        fetchAddresses();
      } else {
        AlertService.swalErrorAlert(response.data.message || t("Error deleting address."));
      }
    } catch (error) {
      AlertService.swalErrorAlert(t("Error deleting address. Please try again."));
    }
  };

  const BasicInfoTab = () => (
    <>
      <Box component="form" onSubmit={handleUpdateBasicInfo} noValidate sx={{ mt: 1 }}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="fullName"
          label={t("Full Name")}
          name="fullName"
          autoComplete="name"
          defaultValue={userData?.name}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          id="mobileNumber"
          label={t("Phone Number")}
          name="mobileNumber"
          autoComplete="tel"
          defaultValue={userData?.phone}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          id="email"
          label={t("Email Address")}
          name="email"
          autoComplete="email"
          defaultValue={userData?.email}
          disabled
        />
        <Typography variant="body2" sx={{ mt: 2, mb: 2 }} color='red'>
          Please Note : At least one Address is mandatory for APC license
        </Typography>
        {addresses.map((address) => (
          <Card key={address.id} sx={{ mb: 2, width: '100%' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="body2" color="text.secondary">
                    {`${address.unit}, ${address.block}, ${address.location}`}
                  </Typography>
                </Box>
                <Box>
                  <IconButton onClick={() => handleEditAddress(address)} size="small">
                    <EditIcon />
                  </IconButton>
                  <IconButton onClick={() => handleDeleteAddress(address._id)} size="small">
                    <DeleteIcon />
                  </IconButton>
                </Box>
              </Box>
            </CardContent>
          </Card>
        ))}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <StyledButton
            variant="contained"
            onClick={handleAddAddress}
            sx={{ mt: 3, mb: 2, mx: 1 }}
            disabled={loading}
          >
            {t("+ Add Address")}
          </StyledButton>
          <StyledButton
            type="submit"
            variant="contained"
            sx={{ mt: 3, mb: 2, mx: 1 }}
            disabled={loading}
          >
            {t("Update Profile")}
          </StyledButton>
        </Box>
      </Box>
    </>
  );

  const PasswordTab = () => {
    const [passwordVisibility, setPasswordVisibility] = useState({
      oldPassword: false,
      newPassword: false,
      confirmPassword: false
    });

    const togglePasswordVisibility = (field) => {
      setPasswordVisibility(prev => ({
        ...prev,
        [field]: !prev[field]
      }));
    };

    return (
      <Box component="form" onSubmit={handleUpdatePassword} noValidate sx={{ mt: 1 }}>
        <TextField
          margin="normal"
          required
          fullWidth
          name="oldPassword"
          label={t("Old Password")}
          type={passwordVisibility.oldPassword ? "text" : "password"}
          id="oldPassword"
          InputProps={{
            endAdornment: (
              <IconButton onClick={() => togglePasswordVisibility('oldPassword')}>
                {passwordVisibility.oldPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            ),
          }}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="newPassword"
          label={t("New Password")}
          type={passwordVisibility.newPassword ? "text" : "password"}
          id="newPassword"
          InputProps={{
            endAdornment: (
              <IconButton onClick={() => togglePasswordVisibility('newPassword')}>
                {passwordVisibility.newPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            ),
          }}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="confirmPassword"
          label={t("Confirm Password")}
          type={passwordVisibility.confirmPassword ? "text" : "password"}
          id="confirmPassword"
          InputProps={{
            endAdornment: (
              <IconButton onClick={() => togglePasswordVisibility('confirmPassword')}>
                {passwordVisibility.confirmPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            ),
          }}
        />
        <StyledButton
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          disabled={loading}
        >
          {t("Update")}
        </StyledButton>
      </Box>
    );
  };


  const DetailedInfoTab = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [formIsValid, setFormIsValid] = useState(false);
    const [companyDetails, setCompanyDetails] = useState({
      companyName: '',
      businessRegNo: '',
      companyRegDate: '',
      businessAddress: '',
      billingAddress: '',
      telephoneNo: '',
      faxNo: '',
      emailAddress: '',
      typeOfBusiness: '',
      businessStructure: '',
      accountPersonName: '',
      accountPersonPosition: '',
      accountPersonTelephone: '',
      accountPersonEmail: '',
      applicantName: '',
      applicantPosition: '',
      applicantTelephone: '',
      applicantEmail: '',
      // paidUpCapital: '',
      // expectedMonthlyPurchases: '',
      APCDocument: { file: null, expiry_date: '' },
      documentsAttached: [],
      EInvoiceInfo: [{ TIN: '' }],
      bankReferences: [{ name: '', branch: '', accountNumber: '' }]
    });
    const [isTCConfirmed, setIsTCConfirmed] = useState(false); // T&C state
    const [openTCDialog, setOpenTCDialog] = useState(false); // Dialog state

    const handleTCClose = () => setOpenTCDialog(false);


    const storeduser = JSON.parse(localStorage.getItem("user"));
    const businessAddressRef = useRef(null);
    const billingAddressRef = useRef(null);
    const businessAutocompleteRef = useRef(null);
    const billingAutocompleteRef = useRef(null);
    useEffect(() => {
      fetchUserInfo();
    }, []);

    useEffect(() => {
      validateForm();
    }, [companyDetails]);

    const initGoogleMaps = () => {
      const loadGoogleMapsScript = () => {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDlKtLygdyr4XpjVE1WcyR7yHuigyq_agw&libraries=places`;
        script.onload = initAutocomplete;
        document.head.appendChild(script);
      };

      if (window.google && window.google.maps) {
        initAutocomplete();
      } else {
        loadGoogleMapsScript();
      }
    };

    const initAutocomplete = () => {
      if (businessAddressRef.current && !businessAutocompleteRef.current) {
        businessAutocompleteRef.current = new window.google.maps.places.Autocomplete(businessAddressRef.current, { types: ['address'] });
        businessAutocompleteRef.current.addListener('place_changed', () => handlePlaceSelect('businessAddress'));
      }
      if (billingAddressRef.current && !billingAutocompleteRef.current) {
        billingAutocompleteRef.current = new window.google.maps.places.Autocomplete(billingAddressRef.current, { types: ['address'] });
        billingAutocompleteRef.current.addListener('place_changed', () => handlePlaceSelect('billingAddress'));
      }
    };

    const handlePlaceSelect = (addressType) => {
      const autocomplete = addressType === 'businessAddress' ? businessAutocompleteRef.current : billingAutocompleteRef.current;
      const place = autocomplete.getPlace();
      if (!place.geometry) {
        //iph todo: 47
        //console.error('No details available for input:', place.name);
        return;
      }

      setCompanyDetails(prevState => ({
        ...prevState,
        [addressType]: place.formatted_address
      }));
    };

    useEffect(() => {
      fetchUserInfo();
    }, []);

    useEffect(() => {
      validateForm();
    }, [companyDetails]);

    const fetchUserInfo = async () => {
      try {
        let payload = {
          functionName: 'getUserInfo',
          postData: {
            user_id: storeduser._id,
          }
        }
        const response = await AddressService.getUserInfo(payload);
        if (response.data.status && response.data.data) {
          setCompanyDetails(prevState => ({
            ...prevState,
            ...response?.data?.data?.data?.[0]?.companyDetails
          }));
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
        AlertService.swalErrorAlert(t("Error fetching user information. Please try again."));
      }
    };

    const validateForm = () => {
      const requiredFields = [
        'companyName', 'businessRegNo', 'companyRegDate', 'businessAddress', 'billingAddress',
        'telephoneNo', 'emailAddress', 'typeOfBusiness', 'businessStructure',
        'accountPersonName', 'accountPersonPosition', 'accountPersonTelephone', 'accountPersonEmail',
        'applicantName', 'applicantPosition', 'applicantTelephone', 'applicantEmail',
        // 'paidUpCapital', 'expectedMonthlyPurchases',
        'bankReferences', 'EInvoiceInfo',
      ];

      const isValid =
        requiredFields.every((field) => companyDetails[field] !== '') &&
        companyDetails.APCDocument.file &&
        companyDetails.APCDocument.expiry_date;

      setFormIsValid(isValid);
    };


    const handleInputChange = (event) => {
      const { name, value } = event.target;
      setCompanyDetails(prevState => ({
        ...prevState,
        [name]: value
      }));
    };

    const [openPdfDialog, setOpenPdfDialog] = useState(false);
    const [pdfToShow, setPdfToShow] = useState(null);



    const handleBankReferenceChange = (index, field, value) => {
      const updatedReferences = [...companyDetails.bankReferences];
      updatedReferences[index] = { ...updatedReferences[index], [field]: value };
      setCompanyDetails(prevState => ({
        ...prevState,
        bankReferences: updatedReferences
      }));
    };

    const handleEInvoiceChange = (index, field, value) => {
      const EInvoiceInfo = [...companyDetails.EInvoiceInfo];
      EInvoiceInfo[index] = { ...EInvoiceInfo[index], [field]: value };
      setCompanyDetails(prevState => ({
        ...prevState,
        EInvoiceInfo: EInvoiceInfo
      }));
    };

    const handleDocumentChange = (event) => {
      const { value, checked } = event.target;
      if (!checked) {
        setCompanyDetails(prevState => ({
          ...prevState,
          documentsAttached: prevState.documentsAttached.filter(doc => doc.document !== value)
        }));
      }
    };

    const handleDocumentToggle = (docType) => {
      setCompanyDetails((prevState) => {
        const isDocumentSelected = prevState.documentsAttached.some(doc => doc.document === docType);

        return {
          ...prevState,
          documentsAttached: isDocumentSelected
            ? prevState.documentsAttached.filter(doc => doc.document !== docType)
            : [...prevState.documentsAttached, { document: docType, file: null }]
        };
      });
    };


    const handleFileUpload = (event, docType) => {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result;
          setCompanyDetails((prevState) => ({
            ...prevState,
            documentsAttached: prevState.documentsAttached.map(doc =>
              doc.document === docType ? { ...doc, file: base64String } : doc
            ),
          }));
        };
        reader.readAsDataURL(file);
      }
    };
    const handleAPCFileUpload = (event) => {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result;
          setCompanyDetails((prevState) => ({
            ...prevState,
            APCDocument: {
              ...prevState.APCDocument,
              file: base64String,
            },
          }));
        };
        reader.readAsDataURL(file);
      }
    };

    const handleAPCExpiryChange = (event) => {
      const expiryDate = event.target.value;
      setCompanyDetails((prevState) => ({
        ...prevState,
        APCDocument: {
          ...prevState.APCDocument,
          expiry_date: expiryDate,
        },
      }));
    };


    // Open PDF in modal
    const handleOpenPdf = (file) => {
      //iph todo: 47
      //console.log("file", file)
      setPdfToShow(file);
      setOpenPdfDialog(true);
    };

    const handleClosePdfDialog = () => {
      setOpenPdfDialog(false);
      setPdfToShow(null);
    };

    const handleSubmit = async (event) => {
      event.preventDefault();
      if (!isTCConfirmed) {
        alert(t("You must accept the Terms and Conditions to submit this form."));
        return;
      }
      setLoading(true);
      try {
        const payload = {
          functionName: 'submitUserInfo',
          postData: { user_id: storeduser._id, companyDetails },
        };
        const response = await AddressService.submitUserInfo(payload);
        response.data.status
          ? AlertService.swalSuccessAlert(t("Information updated successfully."))
          : AlertService.swalErrorAlert(response.data.message || t("Error updating information."));
      } catch (error) {
        console.error("Error submitting user info:", error);
        AlertService.swalErrorAlert(t("Error updating information. Please try again."));
      } finally {
        setLoading(false);
      }
    };


    return (
      <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 3 }}>
        <Typography variant="h6" gutterBottom>A. Account information</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Company/Clinic Name"
              name="companyName"
              value={companyDetails.companyName}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Business Reg. No. (R.O.C)"
              name="businessRegNo"
              value={companyDetails.businessRegNo}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Company Reg. Date"
              name="companyRegDate"
              type="date"
              value={companyDetails.companyRegDate}
              onChange={handleInputChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Business Address"
              name="businessAddress"
              inputRef={businessAddressRef}
              value={companyDetails.businessAddress}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Billing Address"
              name="billingAddress"
              inputRef={billingAddressRef}
              value={companyDetails.billingAddress}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Telephone No."
              name="telephoneNo"
              value={companyDetails.telephoneNo}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Fax No."
              name="faxNo"
              value={companyDetails.faxNo}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="E-mail Address"
              name="emailAddress"
              type="email"
              value={companyDetails.emailAddress}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Type of Business</InputLabel>
              <Select
                name="typeOfBusiness"
                value={companyDetails.typeOfBusiness}
                onChange={handleInputChange}
              >
                <MenuItem value="Clinic">Clinic</MenuItem>
                <MenuItem value="Pharmacy ">Pharmacy</MenuItem>
                <MenuItem value="Doctors ">Doctors </MenuItem>
                {/* <MenuItem value="Manufacturing">Manufacturing</MenuItem>
                <MenuItem value="Trading">Trading</MenuItem>
                <MenuItem value="Services">Services</MenuItem> */}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Business Structure</InputLabel>
              <Select
                name="businessStructure"
                value={companyDetails.businessStructure}
                onChange={handleInputChange}
              >
                <MenuItem value="Sole-Proprietor">Sole-Proprietor</MenuItem>
                <MenuItem value="Partnership">Partnership</MenuItem>
                <MenuItem value="Sendirian Berhad">Sendirian Berhad</MenuItem>
                <MenuItem value="Berhad">Berhad</MenuItem>
                <MenuItem value="Others">Others</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>B. Details of Finance Person In Charge</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Name"
              name="accountPersonName"
              value={companyDetails.accountPersonName}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Position"
              name="accountPersonPosition"
              value={companyDetails.accountPersonPosition}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Telephone No."
              name="accountPersonTelephone"
              value={companyDetails.accountPersonTelephone}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="E-mail Address"
              name="accountPersonEmail"
              type="email"
              value={companyDetails.accountPersonEmail}
              onChange={handleInputChange}
            />
          </Grid>
        </Grid>

        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>C. Details of Applicant / Person In Charge</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Name"
              name="applicantName"
              value={companyDetails.applicantName}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Position"
              name="applicantPosition"
              value={companyDetails.applicantPosition}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Telephone No."
              name="applicantTelephone"
              value={companyDetails.applicantTelephone}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="E-mail Address"
              name="applicantEmail"
              type="email"
              value={companyDetails.applicantEmail}
              onChange={handleInputChange}
            />
          </Grid>
        </Grid>

        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>D. Upload Company Documents</Typography>
        <Grid container spacing={2}>
          {/* <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Paid Up Capital"
              name="paidUpCapital"
              value={companyDetails.paidUpCapital}
              onChange={handleInputChange}
            />
          </Grid> */}
          {/* <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Expected Monthly Purchases"
              name="expectedMonthlyPurchases"
              value={companyDetails.expectedMonthlyPurchases}
              onChange={handleInputChange}
            />
          </Grid> */}
          <Grid item xs={12}>
            <Typography variant="subtitle1">Documents Attached</Typography>
            <Grid container>
              {['Form 9', 'Form 24(Annual Return)', 'Form 49', 'Audited Accounts', 'Borang B/F.'].map((doc) => (
                <Grid item xs={24} sm={24} md={12} key={doc}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={companyDetails.documentsAttached.some(d => d.document === doc)}
                        onChange={() => handleDocumentToggle(doc)}
                        value={doc}
                      />
                    }
                    label={doc}
                  />
                  {companyDetails.documentsAttached.some(d => d.document === doc) && (
                    <>
                      {companyDetails.documentsAttached.find(d => d.document === doc).file ? (
                        <Button
                          variant="outlined"
                          onClick={() => handleOpenPdf(companyDetails.documentsAttached.find(d => d.document === doc).file)}
                        >
                          View Document
                        </Button>
                      ) : (
                        <input
                          type="file"
                          accept="application/pdf,image/*"
                          onChange={(e) => handleFileUpload(e, doc)}
                        />
                      )}
                    </>
                  )}
                </Grid>
              ))}
            </Grid>
            {/* PDF Viewer Dialog */}
            <Dialog open={openPdfDialog} onClose={handleClosePdfDialog} maxWidth="md" fullWidth>
              <DialogTitle>
                {t("Document Preview")}
                <IconButton
                  aria-label="close"
                  onClick={handleClosePdfDialog}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                {pdfToShow && (
                  pdfToShow.includes('data:application/pdf;base64,') ? (
                    <iframe
                      src={`data:application/pdf;base64,${pdfToShow.split(',')[1]}`}
                      width="100%"
                      height="500px"
                      title="PDF Document"
                      style={{ border: 'none' }}
                    />
                  ) : (
                    <img
                      src={pdfToShow}
                      alt="Document"
                      style={{ maxWidth: '100%', maxHeight: '80vh' }}
                    />
                  )
                )}
              </DialogContent>
            </Dialog>
          </Grid>
        </Grid>

        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>E. Upload APC Document</Typography>
        <Grid item xs={24} sm={24} md={12}>
          <Typography variant="subtitle1">APC Document</Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={!!companyDetails.APCDocument.file}
                onChange={() =>
                  setCompanyDetails((prevState) => ({
                    ...prevState,
                    APCDocument: {
                      ...prevState.APCDocument,
                      file: prevState.APCDocument.file ? null : prevState.APCDocument.file,
                    },
                  }))
                }
                value="APC Document"
              />
            }
            label="APC Document"
          />
          {companyDetails.APCDocument.file ? (
            <>

            </>
          ) : (
            <input
              type="file"
              accept="application/pdf,image/*"
              onChange={handleAPCFileUpload}
            />
          )}
        </Grid>
        <Grid item xs={24} sm={24} md={12}>
          <>
            <TextField
              label="Expiry Date"
              type="date"
              value={companyDetails.APCDocument.expiry_date}
              onChange={handleAPCExpiryChange}
              InputLabelProps={{ shrink: true }}
              sx={{ width: '320px', mt: 2 }}
            />
            {companyDetails.APCDocument.file && (
              <Button
                variant="outlined"
                sx={{ ml: 2, mt: 2, height: '55px', width: '160px' }}
                onClick={() => handleOpenPdf(companyDetails.APCDocument.file)}
              >
                View Document
              </Button>
            )}
          </>
        </Grid>
        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>F. E-Invoice Info</Typography>
        {companyDetails.EInvoiceInfo.map((EInvoice, index) => (
          <Grid container spacing={2} key={index} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="TIN"
                value={EInvoice.TIN}
                onChange={(e) => handleEInvoiceChange(index, 'TIN', e.target.value)}
              />
            </Grid>
          </Grid>
        ))}

        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>G. Bank Reference</Typography>
        {companyDetails.bankReferences.map((reference, index) => (
          <Grid container spacing={2} key={index} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Name"
                value={reference.name}
                onChange={(e) => handleBankReferenceChange(index, 'name', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Branch"
                value={reference.branch}
                onChange={(e) => handleBankReferenceChange(index, 'branch', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Account Number"
                value={reference.accountNumber}
                onChange={(e) => handleBankReferenceChange(index, 'accountNumber', e.target.value)}
              />
            </Grid>

            {/* {index > 0 && (
              <Grid item xs={12}>
                <Button onClick={() => removeBankReference(index)}>Remove Bank Reference</Button>
              </Grid>
            )} */}
          </Grid>
        ))}
        {/* <Button onClick={addBankReference}>Add Bank Reference</Button> */}
        {/* T&C Checkbox */}
        <FormControlLabel
          control={
            <Checkbox
              checked={isTCConfirmed}
              onChange={(e) => setIsTCConfirmed(e.target.checked)}
            />
          }
          label={
            <span>
              {t("I agree to the")}{" "}
              <Button variant="text" onClick={() => setOpenTCDialog(true)}>
                {t("Terms and Conditions")}
              </Button>
            </span>
          }
        />

        <Box sx={{ mt: 3 }}>
          <StyledButton
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            disabled={loading || !formIsValid}
          >
            {t("Update Detailed Information")}
          </StyledButton>
        </Box>
        {/* T&C Dialog */}
        <TermsConditionsDialog open={openTCDialog} onClose={handleTCClose} t={t} />
      </Box>
    );
  };

  if (!userData) return null;

  return (
    <Fragment>
      <div className="app-main__outer">
        <div className="app-main__inner">
          <Container maxWidth='md'>
            <Box sx={{ my: 4, textAlign: 'center' }}>
              <Avatar
                sx={{ width: 100, height: 100, margin: 'auto', bgcolor: 'error.main', fontSize: 40 }}
              >
                {userData.name.charAt(0).toUpperCase()}
              </Avatar>
              <Typography variant="h5" sx={{ mt: 2 }}>{userData.name}</Typography>
              <Typography variant="body1" color="text.secondary">{userData.phone}</Typography>
            </Box>

            <Tabs value={tabValue} onChange={handleTabChange} centered>
              <StyledTab label={t("Basic Info")} />
              <StyledTab label={t("Password")} />
              <StyledTab label={t("Detailed Info")} />
            </Tabs>

            <Box sx={{ mt: 3 }}>
              {tabValue === 0 && <BasicInfoTab />}
              {tabValue === 1 && <PasswordTab />}
              {tabValue === 2 && <DetailedInfoTab />}
            </Box>
          </Container>
        </div>
      </div>
    </Fragment>
  );
};

export default MyProfile;
